import {createSelector} from 'reselect';

import {UserAppState} from './user-types';

export const userSelector = createSelector(
  (state: UserAppState) => state.user,
  item => item,
);
